export default __webpack_public_path__ + "static/media/HR.f5ec8eee.png";